/**
 * CM > IPS > 침입탐지 프로파일 > 컬럼설정 팝업
 *
 * @since 2021-11-04
 * @author wj_tams_dev04
 */
export const state = () => ({
  // 현재 컬럼
  fields: []
})

export const mutations = {
  initStore (state) {
    state.fields = []
  },
  /**
   * 패턴 설정을 스토어에 적용한다.
   */
  setFields (state, fields) {
    state.fields = _.cloneDeep(fields)
  }
}
